export default __webpack_public_path__ + "static/media/twitter-logo.9f722d19.svg";